//slider is not a valid custom element name, using slider-carousel instead
if (!customElements.get("slider-carousel")) {
  // Create a class for the element
  class Slider extends HTMLElement {
    constructor() {
      super();
    }
  }

  class Slide extends Slider {
    constructor() {
      super();

      this.init();
    }

    init() {
      let buttons = this.querySelectorAll("button");
      for (let index = 0; index < buttons.length; index++) {
        const button = buttons[index];
        button.addEventListener("click", this.changeSlide.bind(this));
      }
    }

    changeSlide(event) {
      let button = event.target.closest("button");
      let direction = button.dataset.direction;
      let current = this.dataset.current;
      let next = document.querySelector(`#${this.dataset.next}`);
      let previous = document.querySelector(`#${this.dataset.previous}`);

      if (next && direction === 'next') {
        this.classList.add("hidden");
        next.classList.remove("hidden");
      }

      if (next && direction === 'previous') {
        this.classList.add("hidden");
        previous.classList.remove("hidden");
      }
    }
  }

  customElements.define("slider-carousel-slide", Slide);
}
